import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import TanstackTable from "../../../Components/Table/TanstackTable";

const FleetEdge = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );
  const FleetEdgeApi = async (selectedFilter) => {
    try {
      const res = await axInst.post("pvin/fleetedge", selectedFilter);
      return res.data;
    } catch (error) {
      console.error("Error fetching fleet details:", error.response || error);
      throw error;
    }
  };

  const columns = useMemo(
    () => [
      { header: "PPL", accessorKey: "PPL" },
      { header: "PL", accessorKey: "PL" },
      { header: "Chassis No", accessorKey: "ASSET_NUMBER" },
      { header: "Average FE", accessorKey: "Average_FE" },
      { header: "Average KM Run", accessorKey: "Average_KM_run" },
      {
        header: "Vehicle Registration Number",
        accessorKey: "VEHICLE_REGISTRATION_NUMBER",
      },
      {
        header: "Driving Behaviour Cluster",
        accessorKey: "driving_behaviour_cluster",
        cell: ({ row }) => {
          const value = row.original.driving_behaviour_cluster;

          if (!value)
            return <div className="text-center text-gray-500">N/A</div>;
          const bgColor =
            value === "GREEN"
              ? "bg-green-500"
              : value === "YELLOW"
              ? "bg-yellow-500"
              : value === "RED"
              ? "bg-red-500"
              : "bg-gray-400";

          return (
            <div
              className={`${bgColor} text-white text-center rounded px-2 py-1`}
            >
              {value}
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <TanstackTable
      heading="Fleet Edge Details"
      columns={columns}
      apiFn={FleetEdgeApi}
      queryKey="FleetEdge"
      filter={selectedFilter}
      theadColor="bg-[#1F4B70]"
      height="max-h-[250px]"
      border="border"
    />
  );
};

export default FleetEdge;
